/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'
import { goToHomeHybridMod } from '@/navigation/CSR/goToHomeHybridMod'
import getLocale from '@/stores/locales'
import { getSimpleViewOptions } from '@/useCases/simpleViewOptions'
import isSSR from '@/utils/isSSR'
import PhIcon from '@mercadoni/sinister/dist/cjs/PhIcon'
import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client/contexts'
import { trackEvent } from '@mercadoni/sinister/dist/cjs/monitors/services'
import { Button } from 'antd'
import { usePathname, useRouter } from 'next/navigation'
import Logo from '../Logo'
import styles from './SimpleHeader.module.scss'
const SimpleHeader = () => {
  const {
    header,
    domain,
    seoConfig: { name = '' } = {},
    clientId,
  } = UseClientModelContext()
  const { simpleHeader: copy } = getLocale() || {
    simpleHeader: {
      placeholder: '',
    },
  }
  const router = useRouter()

  const onClickLogo = async () => {
    trackEvent({
      eventName: 'header_logo',
      clientId,
    })
    await goToHomeHybridMod(router)
  }
  const pathname = usePathname()
  const simpleViewOptions = getSimpleViewOptions({
    copy,
    router,
    pathname,
  })

  const _domain = domain || (isSSR() ? '' : window.location.origin) || ''

  return (
    <div data-testid="header-container" className={styles.headerContainer}>
      <header className={styles.header}>
        {simpleViewOptions.displayBackButton && (
          <Button
            type="text"
            className={styles.headerBack}
            onClick={simpleViewOptions.onClickBack}
          >
            <PhIcon size={20} className="ph-caret-left" />
            <div className={styles.headerBackText}>
              {simpleViewOptions.textBackButton}
            </div>
          </Button>
        )}
        <Logo
          className={styles.headerLogo}
          src={header?.logo}
          slug={name}
          domain={_domain}
          onClick={onClickLogo}
          height={40}
        />
      </header>
    </div>
  )
}

export default SimpleHeader
